import {
  FETCH_TEST_SUCCESS,
  SET_GROUP_QUESTION,
  SET_CURRENT_PAGE,
  SET_TEST_PROCESS,
  SET_TEST_RESULT,
  RESET_DATA_TEST,
} from 'app/constants/tests';
import { Question, Group, Test, Passage } from 'types/test';
import { HYDRATE } from 'next-redux-wrapper';
import first from 'lodash/first';
import pick from 'lodash/pick';
import omit from 'lodash/omit';

export interface TestData {
  groupQuestions: Group[];
  currentPage: number;
  process: string;
  result: Test;
  test: Test;
}

let initState = {
  groupQuestions: [],
  process: "init",
  currentPage: 0,
  result: {} as Test,
  test: {} as Test,
}

const test = (state: TestData = initState, action: any) => {
  switch (action.type) {
    case HYDRATE:
      return {
        ...state,
        ...action.payload?.test || {},
      };

    case RESET_DATA_TEST:
      return {
        ...initState,
        currentPage: getCurrentPage(state?.test.passages, state.groupQuestions),
        test: state.test,
        process: 'ready',
        groupQuestions: resetGroupQuestions(state.groupQuestions),
      };

    case SET_TEST_RESULT:
      return {
        ...state,
        result: chunkQuestionToPage(action.payload as Test),
        process: 'complete'
      };

    case SET_TEST_PROCESS:
      return {
        ...state,
        process: action.payload,
      };

    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case SET_GROUP_QUESTION:
      return {
        ...state,
        groupQuestions: action.payload,
      };

    case FETCH_TEST_SUCCESS:
      const test = chunkQuestionToPage(action.payload as Test);

      return {
        ...state,
        test: pick(test, ['id', 'title', 'slug', 'category_id', 'audio', 'questions_count', 'created_at', 'updated_at', 'passages', 'grammar']),
        currentPage: getCurrentPage(test.passages, test?.group_questions),
        groupQuestions: test.group_questions,
      }
    default:
      return state;
  }
}

export const chunkQuestionToPage = (data: Test) => {
  let questionNumber = 0;
  const newGroupQuestions: Group[] = data.group_questions
    .sort((a, b) => (a.part_id ?? 0) - (b.part_id ?? 0))
    .map((group: Group) => {
      const list_questions = group.list_question.map((question: Question) => {
        questionNumber += 1;
        return {
          ...question,
          page: group.part_id || 0,
          number: questionNumber,
          type: group.group_type,
        };
      });

      return {
        ...group,
        page: group.part_id || 0,
        category_id: data.category_id,
        list_question: list_questions,
      };
    });

  return {
    ...data,
    group_questions: newGroupQuestions,
  };
}

export const getCurrentPage = (passages: Passage[] = [], groupQuestions: Group[] = []) => {
  if (passages.length > 0) {
    return first(passages)?.passage_number;
  }

  return first(groupQuestions)?.part_id || 0;
}

export const resetGroupQuestions = (groupQuestions: Group[]) => {
  return groupQuestions.map((group: Group) => {
    return {
      ...group,
      list_question: group.list_question.map((question: Question) => {
        return omit(question, 'answer');
      }),
    };
  })
}

export default test
